export const AppointmentBlock = {
  flow: 'y',
  gap: 'X',
  padding: 'Z',
  round: 'Y',
  background: 'inkMid',
  cursor: 'pointer',
  borderLeft: (el, s) => {
    const st = s.status
    if (st === 'Confirmed') return '4px solid green'
    if (st === 'Unconfirmed') return '4px solid amber'
    if (st === 'InChair') return '4px solid teal'
    if (st === 'CheckedOut') return '4px solid inkMuted'
    if (st === 'NoShow') return '4px solid red'
    if (st === 'Cancelled') return '4px solid inkBorder'
    return '4px solid inkBorder'
  },
  transition: 'background 0.15s',
  ':hover': { background: 'inkSurface' },

  PatientName: {
    text: (el, s) => s.patient || '',
    fontSize: 'Z',
    fontWeight: '600',
    color: 'inkText'
  },
  ProcedureSummary: {
    text: (el, s) => s.procedure || '',
    fontSize: 'Z',
    color: 'inkMuted'
  },
  TimeInfo: {
    flow: 'x',
    gap: 'Y',
    Time: { text: (el, s) => s.time || '', fontSize: 'Y', color: 'inkMuted' },
    Duration: { text: (el, s) => s.duration ? `${s.duration} min` : '', fontSize: 'Y', color: 'inkMuted' }
  },
  ProviderInfo: {
    text: (el, s) => s.provider || '',
    fontSize: 'Y',
    color: 'inkMuted',
    fontStyle: 'italic'
  }
}
